import React from 'react';
import AnalyticsTabbed from './AnalyticsTabbed';

const Analytics: React.FC = () => {
  return <AnalyticsTabbed isJumperMode={false} />;
};

export default Analytics;

